import api from '@/utils/api';

const state = {
    dashboard: {},
    reports: [],
    eventProperties: [],
    admins: [],
};

const mutations = {
    setDashboard(state, data) {
        state.dashboard = data;
    },
    setReports(state, data) {
        state.reports = data;
    },
    setEventProperties(state, data) {
        state.eventProperties = data;
    },
    setAdmins(state, data) {
        state.admins = data;
    },
};

const actions = {
    async getDashboard({ commit }) {
        commit('setLoading', 'dashboard');
        const { data } = await api.get('/dashboards/me');
        commit('setDashboard', data);
        commit('unsetLoading', 'dashboard');
    },
    async putDashboard({ commit }, { id, data }) {
        commit('setLoading', 'dashboard');
        await api.put(`/dashboards/${id}`, data);
        commit('unsetLoading', 'dashboard');
    },
    async getReports({ commit }) {
        commit('setLoading', 'reports');
        const { data } = await api.get('/reports');
        commit('setReports', data.results);
        commit('unsetLoading', 'reports');
    },
    async getReportResults({ commit }, { id, params }) {
        try {
            commit('setLoading', `reportResults_${id}`);
            const { data } = await api.get(`/reports/${id}/results`, { params });
            return data;
        } catch (e) {
            console.error(e);
        } finally {
            commit('unsetLoading', `reportResults_${id}`);
        }
    },
    async getEventProperties({ commit }) {
        commit('setLoading', 'properties');
        const { data } = await api.get('/event-properties');
        commit('setEventProperties', data.results);
        commit('unsetLoading', 'properties');
    },
    async getAdmins({ commit }) {
        commit('setLoading', 'admins');
        const { data } = await api.get('/admins');
        commit('setAdmins', data.results);
        commit('unsetLoading', 'admins');
    },
};

const uniqueValues = (arr = []) => {
    const set = new Set();
    arr.filter(item => item).forEach(set.add, set);
    const newArr = Array.from(set);
    newArr.sort();
    return newArr;
}

const getters = {
    dashboard: s => s.dashboard,
    reports: s => s.reports,
    eventProperties: state => {
        const tagKeys = uniqueValues(state.eventProperties.map(p => p.tag_key));
        return tagKeys;
    },
    eventPropertyValues: state => (key) =>{
        const relevantValues = state.eventProperties.filter(p => p.tag_key === key);
        const tagValues = uniqueValues(relevantValues.map(p => p.tag_value));
        return tagValues;
    },
    admins: s => s.admins,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
